import { ArrowRightIcon, Form, handleApiRequest } from "@cpj-ai/panel-npm-package";
import {
  UpdateInterestedJobsMutation,
  UpdateInterestedJobsMutationVariables,
  useGetInterestedJobsQuery,
  useUpdateInterestedJobsMutation,
} from "@graphql/generated";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { getInputConfig } from "./formCofig";

interface JobInterestedTabContentProps {
  goToNextTab: () => void;
}

const JobInterestedTabContent: React.FC<JobInterestedTabContentProps> = ({ goToNextTab }) => {
  const formHandler = useForm();

  const { data: userData, refetch } = useGetInterestedJobsQuery();
  const [updateInterestedJObs, { loading: submitLoading }] = useUpdateInterestedJobsMutation();

  const handleSubmit = useCallback(async () => {
    const formData = formHandler.getValues();
    if (!formData?.interestedJobs) {
      toast.error("Please select interested jobs.");
      return;
    }

    await handleApiRequest<UpdateInterestedJobsMutation, UpdateInterestedJobsMutationVariables>({
      apiFunction: updateInterestedJObs,
      variables: {
        employmentStatus: formData?.employmentStatus,
        interestedJobs: formData?.interestedJobs?.map((item: any) => item.node.id),
      },
      componentName: "InterestedJobsForm",
      actionName: "updateInterestedJobs",
      successMessage: "Interested jobs updated successfully",
      fallbackErrorMessage: "Failed to update interested jobs. Please try again.",
      extraErrorContext: {
        employmentStatus: formData?.employmentStatus,
        jobsCount: formData?.interestedJobs?.length,
      },
      onSuccess: () => {
        refetch();
        goToNextTab();
      },
    });
  }, [formHandler, goToNextTab, refetch, updateInterestedJObs]);

  useEffect(() => {
    if (!userData) return;

    formHandler.reset({
      employmentStatus: userData?.me?.profile?.employmentStatus,
      interestedJobs: userData?.me?.profile?.interestedJobs?.edges?.map((item) => ({
        node: {
          id: item?.node?.id,
          title: item?.node?.title,
          requireAppearanceData: item?.node?.requireAppearanceData,
        },
      })),
    });
  }, [formHandler, userData]);

  return (
    <div className="pt-3 flex flex-col gap-4">
      <Form
        wrapInCard={false}
        formHandler={formHandler}
        inputConfigs={getInputConfig()}
        showCancel={false}
        className="mt-0"
        submitProps={{
          onClick: formHandler.handleSubmit(handleSubmit),
          isLoading: submitLoading,
          isDisabled: submitLoading,
          children: "Save & Next",
          endContent: <ArrowRightIcon stroke="#fff" className="w-4 h-4" />,
        }}
      />
    </div>
  );
};

export default JobInterestedTabContent;
